module.exports = __webpack_public_path__ + "img/coloring-slider-house.a0ab8a45.svg";